import React from "react";
import '../../App.css'
import Main from '../Main';
import Blog from "../projects/Blog";

function Home() {
    return(
        <>
            <Main />
            <Blog />

        </>
    )

}

export default Home
